import type { CTCreateReportSettings } from './schema';
import { CTCreateReportResponseSchema } from './schema';
import { HTTP_METHOD } from '../../../consts';
import type { ApiCallOptions, Transport } from '../../../types';

export const createCTReportApi = (transport: Transport) => ({
  createReport: (settings: CTCreateReportSettings, options?: ApiCallOptions) =>
    transport(`/seo-tools/api/v2/ct/add`, {
      method: HTTP_METHOD.POST,
      body: settings,
      deserializer: CTCreateReportResponseSchema,
      signal: options?.signal
    })
});

export type CTReportApi = ReturnType<typeof createCTReportApi>;
